// Mutation hook - usuniecie stopki (twarde DELETE).
// DELETE /api/ui/sales-crm/mailbox/signatures/{id}
// Sprint 3 v4.1.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IDeleteMailSignatureResponse } from 'api/types/signature';
import { MAIL_SIGNATURES_QUERY_KEY_BASE } from 'api/endpoints/useGetMailSignatures';

const deleteMailSignature = (id: number): Promise<IDeleteMailSignatureResponse> =>
  axios.delete(`/sales-crm/mailbox/signatures/${id}`);

export const useDeleteMailSignature = (
  options?: UseMutationOptions<IDeleteMailSignatureResponse, IError, number>
) => {
  const queryClient = useQueryClient();
  return useMutation<IDeleteMailSignatureResponse, IError, number>(deleteMailSignature, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries([MAIL_SIGNATURES_QUERY_KEY_BASE]);
      options?.onSuccess?.(data, variables, context);
    }
  });
};
